var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeskAccessories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22.765,
    viewBox: "0 0 32 22.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    id: "reception-bell-svgrepo-com",
    d: "M31.592,51.011H.409A.409.409,0,0,1,0,50.6V48.882a.409.409,0,0,1,.409-.409H.467v-.9a.409.409,0,0,1,.409-.409H15.591V46.6H2.791a.409.409,0,0,1-.409-.409A13.641,13.641,0,0,1,13.6,32.781a.391.391,0,0,1,.029-.046l1.026-1.389a1.571,1.571,0,0,1,.936-.58v-.373a1.264,1.264,0,0,1-.682-.454L14.14,28.9a.409.409,0,0,1,.329-.652h3.063a.409.409,0,0,1,.329.652l-.77,1.041a1.264,1.264,0,0,1-.682.454v.373a1.571,1.571,0,0,1,.936.58l1.026,1.389a.428.428,0,0,1,.029.046A13.641,13.641,0,0,1,29.618,46.187a.409.409,0,0,1-.409.409h-12.8v.565H31.125a.409.409,0,0,1,.409.409v.9h.058a.409.409,0,0,1,.409.409V50.6A.408.408,0,0,1,31.592,51.011ZM.817,50.194H31.183v-.9H.817Zm.467-1.721H30.716v-.5H1.284ZM16,45.778H28.794a12.8,12.8,0,0,0-25.588,0ZM14.768,32.569h2.464l-.545-.737A.855.855,0,0,0,16,31.539h0a.855.855,0,0,0-.687.292Zm.511-3.506.288.39a.616.616,0,0,0,.866,0l.288-.39ZM6.641,39.991a.409.409,0,0,1-.357-.608c1.434-2.568,4.81-4.306,4.953-4.379a.409.409,0,0,1,.37.729c-.033.017-3.3,1.7-4.61,4.049A.408.408,0,0,1,6.641,39.991Z",
    transform: "translate(0 -28.246)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskAccessories);
export default __webpack_public_path__ + "static/media/deskAccessories.10cdd11748072b3a3f97754331405eaa.svg";
export { ForwardRef as ReactComponent };